////////LIBRARY/////////
import React, { useState, useEffect, Fragment } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { cloneDeep, isUndefined, map, reduce, isNull, isEqual } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import Modals from '../../../components/Modals'
import theme from '../../../theme/theme'
import ToggleFilters from '../../../components/Ui/ToggleFilters'
import Table from '../../../components/Table'
import { PageTitle, PageWrapperActionValidate, InputLogin, ErrorInputMsg } from '../../../theme/GlobalCss'
import ImgButton from '../../../components/Ui/ImgButton'
import UseDatePicker from '../../../hooks/UseDatePicker'
import { campaignPromoActionCreators } from '../../../store/actions'
import PromoCampaignUpdateSecondLine from './PromoCampaignUpdateSecondLine'
import PriceFormatter from '../../../helpers/PriceFormatter'
/////////ASSETS/////////
import CloseButtonIcon from '../../../assets/icones/global/close-white.svg'
import Calendar from '../../../assets/icones/global/calendar.svg'

//////STYLED//////
const PriceCampaignWrapper = styled.div`
	position: relative;
`
const PromoCampaignHeader = styled.div`
	display: flex;
	& > :first-child {
		margin: 0px 15px 0px 0px;
	}
	& > * {
		top: 0px !important;
	}
	& > :last-child {
		margin-left: 25px;
	}
	margin-bottom: 15px;
	align-items: center;
	justify-content: space-between;
`
const PromoHeaderLeftSide = styled.div`
	display: flex;
	justify-content: flex-start;
	& > * {
		margin-right: 30px;
	}
`
const PromoHeaderRightSide = styled.div`
	display: flex;
	justify-content: flex-end;
`
const ButtonSize = styled.div`
	display: flex;
	height: 32px;
	width: max-content;
`
const PromoCampaignFilters = styled.div`
	position: relative;
	padding-right: 17px;
	& > * {
		margin: 0px 7px;
	}
	& > :first-child img {
		max-height: 24px;
		margin: 0px 10px 0px 0px;
	}
	display: flex;
	flex-direction: row;
`
const PromoCampaignContent = styled.div`
	overflow: auto;
	padding: 0px 30px;
	background-color: #f1f1f1;
`
const PromoCampaignInputDate = styled.div`
	display: flex;
	& p {
		margin: 0;
	}
	align-items: center;
`
const PromoCampaignInputName = styled.div`
	display: flex;
	& p {
		margin: 0px 15px 0px 0px;
	}
	align-items: center;
`
const DatePickerWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`
const DatePickerCampaignIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	margin: 0px 8px 0px 15px;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const PageWrapperActions = styled.div`
	display: flex;
	flex-direction: row-reverse;
`
//////STYLED//////

const PromoCampaignUpdateHandler = (props) => {
	const updateMode = props.updateMode
	const currency = props.data.currency.symbol
	const isStarted = props.data?.promotionStatus?.subFlow === '050' ?? true

	const [stateDefaultValues, setStateDefaultValues] = useState({
		campaignName: '',
	})

	const [promotionItemLines, setPromotionItemLines] = useState([])

	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const { register, handleSubmit, errors, setValue, getValues } = useForm({
		mode: 'onChange',
		defaultValues: stateDefaultValues,
	})

	const [dateCampaignShowModal, dateCampaignOpenDateModalHandler, dateCampaignRenderModal, dateCampaignStateDate, setStartDate, setEndDate] =
		UseDatePicker({
			defaultDateStart: props.data?.dateStart ? moment(props.data.dateStart).toDate() : moment().toDate(),
			defaultDateEnd: moment(props.data?.endDate).toDate(),
			noPastDate: true,
			disableEndDate: false,
			disableStartDate: isStarted,
			ifCancel: true,
			step: true,
			insideModal: true,
		})

	const [titleFocusIn, setTitleFocusIn] = useState()
	const [titleFocusOut, setTitleFocusOut] = useState()
	const [countFocusIn, setCountFocusIn] = useState(0)
	const [countFocusOut, setCountFocusOut] = useState(0)
	const [isFocused, setIsFocused] = useState(false)

	const promoCampaignActions = bindActionCreators(campaignPromoActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const onSubmit = (data) => {
		const promoType = props.data.promotionType.id

		const updatedData = cloneDeep(data)

		updatedData.priceValue = map(props.data.promotionItemLines, (elem) => ({
			...data.priceValue[elem.lineNumber],
			idItemKiosk: promoType === 1 ? elem.idItem : elem.idItemKiosk,
		}))
		if (countFocusIn === 0) {
			promoCampaignActions.updateCampaignPromo(props.data.id, {
				campaignName: titleFocusIn,
				dateStart: moment(dateCampaignStateDate.date.startDate).toDate(),
				dateEnd: moment(dateCampaignStateDate.date.endDate).toDate(),
				campaignLines: reduce(
					updatedData.priceValue,
					(result, elem) => {
						!isUndefined(elem) &&
							elem.idItemKiosk &&
							result.push({
								idItemKiosk: Number(elem.idItemKiosk),
								itemPrice: Number(elem.actualStandardPrice),
								depositPrice: !isUndefined(elem.actualDepositPrice) ? Number(elem.actualDepositPrice) : null,
								quantity: Number(elem.quantity),
							})
						return result
					},
					[]
				),
			})
		} else if (countFocusOut > 0) {
			promoCampaignActions.updateCampaignPromo(props.data.id, {
				campaignName: titleFocusOut,
				dateStart: moment(dateCampaignStateDate.date.startDate).toDate(),
				dateEnd: moment(dateCampaignStateDate.date.endDate).toDate(),
				campaignLines: reduce(
					updatedData.priceValue,
					(result, elem) => {
						!isUndefined(elem) &&
							elem.idItemKiosk &&
							result.push({
								idItemKiosk: Number(elem.idItemKiosk),
								itemPrice: Number(elem.actualStandardPrice),
								depositPrice: !isUndefined(elem.actualDepositPrice) ? Number(elem.actualDepositPrice) : null,
								quantity: Number(elem.quantity),
							})
						return result
					},
					[]
				),
			})
		} else {
			promoCampaignActions.updateCampaignPromo(props.data.id, {
				campaignName: data.campaignName,
				dateStart: moment(dateCampaignStateDate.date.startDate).toDate(),
				dateEnd: moment(dateCampaignStateDate.date.endDate).toDate(),
				campaignLines: reduce(
					updatedData.priceValue,
					(result, elem) => {
						!isUndefined(elem) &&
							elem.idItemKiosk &&
							result.push({
								idItemKiosk: Number(elem.idItemKiosk),
								itemPrice: Number(elem.actualStandardPrice),
								depositPrice: !isUndefined(elem.actualDepositPrice) ? Number(elem.actualDepositPrice) : null,
								quantity: Number(elem.quantity),
							})
						return result
					},
					[]
				),
			})
		}
	}

	// if we detect focus on input we increment a counter and set titleFocusIn
	// from the second focus in we have to use titleFocusOUt
	const handleFocusIn = () => {
		const countCp = cloneDeep(countFocusIn)
		setCountFocusIn(countCp + 1)
		if (!isUndefined(titleFocusOut) && !isEqual(titleFocusOut, titleFocusIn)) {
			setValue('campaignName', titleFocusOut)
		} else {
			setValue('campaignName', titleFocusIn)
		}
		setIsFocused(true)
	}

	//en cas de sortie de champ on set un titre de focus out et un bool a false
	const handleDetectFocusOut = (e) => {
		const countFocusOutCp = cloneDeep(countFocusOut)
		setCountFocusOut(countFocusOutCp + 1)
		setTitleFocusOut(e.target.value)
		setIsFocused(false)
	}

	const handleTruncateString = (str, num) => {
		// If the length of str is less than or equal to num
		// just return str--don't truncate it.
		if (str.length <= num) {
			return str
		}
		// Return str truncated with '...' concatenated to the end of str.
		return str.slice(0, num) + '...'
	}

	const handleCloseModal = () => {
		props.closeModalHandler()
		setCountFocusIn(0)
		setCountFocusOut(0)
		setTitleFocusOut()
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const columns = [
		{
			titleColumnCampaign: true,
			withTaxes: true,
			errors: errors,
			callErrors: props?.campaignErrors,
			isStarted: isStarted,
			register: register,
			currency: currency,
			component: () => <div>{translations['page__promotionManagement__creation_table_actualValues']}</div>,
		},
		{
			dataHook: 'kioskCode',
			headerName: translations['page__promotionManagement__tableHeader_expand_kioskCode'],
			sortable: true,
		},
		{
			dataHook: 'store',
			headerName: translations['page__promotionManagement__tableHeader_expand_store'],
			sortable: true,
		},
		{
			dataHook: 'itemFamily.translationKey',
			headerName: translations['page__promotionManagement__tableHeader_expand_family'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
		},
		{
			dataHook: 'itemBrand.label',
			headerName: translations['page__promotionManagement__creation_tableHeader_brand'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'label',
			headerName: translations['page__promotionManagement__creation_tableHeader_product'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'actualStandardPrice',
			headerName: translations['page__promotionManagement__creation_tableHeader_itemPrice'],
			sortable: true,
			isAuthorize: true,
			component: (_props) => `${_props?.row?.actualStandardPrice}${currency}`,
		},
		{
			dataHook: 'actualStandardPrice',
			headerName: translations['page__promotionManagement__creation_tableHeader_convert'],
			sortable: true,
			isAuthorize: true,
			component: (_props) =>
				`${PriceFormatter.vatConverter(false, _props?.row?.actualStandardPrice, _props?.row?.standardPriceVATRate)}${currency}`,
		},
		{
			dataHook: 'actualDepositPrice',
			headerName: translations['page__promotionManagement__creation_tableHeader_depositPrice'],
			sortable: true,
			isAuthorize: true,
			component: (_props) => (isNull(_props?.row?.actualDepositPrice) ? `0,00${currency}` : `${_props?.row?.actualDepositPrice}${currency}`),
		},
		{
			dataHook: 'available',
			headerName: translations['page__promotionManagement__creation_tableHeader_availableStock'],
			sortable: true,
		},
		{
			dataHook: 'capacity',
			headerName: translations['page__promotionManagement__creation_tableHeader_capacity'],
			sortable: true,
		},
	]

	const config = {
		name: '',
		fixedColumnSelection: true,
		isCampaign: true,
		campaignValues: {
			campaignComponent: PromoCampaignUpdateSecondLine,
		},
		noWindowing: true,
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	// to split the string we need to apply a test with boolean
	useEffect(() => {
		if (!isUndefined(titleFocusOut) && !isFocused) {
			setValue('campaignName', handleTruncateString(titleFocusOut, 25))
		}
	}, [titleFocusOut, isFocused])

	useEffect(() => {
		if (!props?.successCreateCampaign) return
		props.closeModalHandler()
	}, [props?.successCreateCampaign])

	/* 	// Every time props data change, we set a new name and date
		useEffect(() => {
			setStartDate(moment(props.data.dateStart).toDate())
			if (props.data?.label?.length > 0) {
				// on data load we set the campaign name
				setTitleFocusIn(props.data.label)
				setValue("campaignName", handleTruncateString(props.data.label, 25))
				setStateDefaultValues(getValues())
			}
		}, [props.data]) */

	// Everytime props data change, we set a new name and date
	useEffect(() => {
		setStartDate(moment(props?.data?.dateStart).toDate())
		setEndDate(moment(props?.data?.endDate).toDate())

		if (props?.data?.label?.length > 0) {
			setValue('campaignName', handleTruncateString(props?.data?.label, 25))
			setTitleFocusIn(props?.data?.label)
			setStateDefaultValues(getValues())
		}

		setPromotionItemLines(props?.data?.promotionItemLines)

		return () => {
			setStateDefaultValues({ campaignName: '' })
			promoCampaignActions.resetCampaignPromo()
			props.closeModalHandler()
		}
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Modals closeModalHandler={handleCloseModal} showModal={props?.showModal} minWidth={1200}>
			{dateCampaignRenderModal()}
			<PriceCampaignWrapper>
				<form onSubmit={handleSubmit(onSubmit)}>
					<PromoCampaignHeader>
						<PromoHeaderLeftSide>
							<PageTitle> {translations['page__promotionManagement__creation_title']}</PageTitle>
							{
								// ( updateMode ) &&
								<>
									<PromoCampaignInputDate>
										<PageTitle>{translations['page__promotionManagement__creation_table_date']}</PageTitle>
										<DatePickerCampaignIcon onClick={dateCampaignOpenDateModalHandler} />
										<DatePickerWrapper>
											<PageTitle>{`${moment(dateCampaignStateDate.date.startDate).format('DD/MM/YYYY')}`}</PageTitle>
											<span>&nbsp;{'à'}&nbsp;</span>
											<PageTitle>{`${moment(dateCampaignStateDate.date.startDate).format('HH:mm')}`}</PageTitle>
											<span>&nbsp;{'au'}&nbsp;</span>
											<PageTitle>{`${moment(dateCampaignStateDate.date.endDate).format('DD/MM/YYYY')}`}</PageTitle>
											<span>&nbsp;{'à'}&nbsp;</span>
											<PageTitle>{`${moment(dateCampaignStateDate.date.endDate).format('HH:mm')}`}</PageTitle>
										</DatePickerWrapper>
									</PromoCampaignInputDate>
									<PromoCampaignInputName>
										<PageTitle>{translations['page__promotionManagement__creation_table_name']}</PageTitle>
										<InputLogin
											name="campaignName"
											type="text"
											disabled={isStarted}
											onFocus={() => handleFocusIn()}
											onBlur={(e) => handleDetectFocusOut(e)}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 100,
													message: `100 ${translations['common__text__charMax']}`,
												},
											})}
										/>
										{errors.campaignName && <ErrorInputMsg>{errors.campaignName.message}</ErrorInputMsg>}
									</PromoCampaignInputName>
								</>
							}
						</PromoHeaderLeftSide>
						<PromoHeaderRightSide>
							<Fragment>
								{!updateMode && (
									<PromoCampaignFilters>
										<ButtonSize>
											<ToggleFilters
												checked={true}
												name="withTTC"
												size={'large'}
												disabled
												labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
												labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
											/>
										</ButtonSize>
									</PromoCampaignFilters>
								)}
							</Fragment>
							<PageWrapperActions>
								<PageWrapperActionValidate unlocked />
								<ImgButton
									img={CloseButtonIcon}
									action={() => handleCloseModal()}
									color={theme.colors.error}
									margin={'5px'}
									as={'div'}
									hover={theme.colors.hoverError}
								/>
							</PageWrapperActions>
						</PromoHeaderRightSide>
					</PromoCampaignHeader>
					<PromoCampaignContent>
						{translations && <Table inputColumns={columns} inputData={promotionItemLines} inputConfig={config} />}
					</PromoCampaignContent>
				</form>
			</PriceCampaignWrapper>
		</Modals>
	)
}

PromoCampaignUpdateHandler.propTypes = {}
PromoCampaignUpdateHandler.defaultPropTypes = {}

export default PromoCampaignUpdateHandler
